function addToCart(body) {
  return new Promise((resolve, reject) => {
       fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(body)
        })
        .then(response => {
          return response.json();
        })
        .then(data => {
          const cart = document.querySelector('cart-drawer');
          cart.renderContents(data);
  
          const currentUrl = window.location.href
          fetch(currentUrl, {
            method: "GET",
          })
          .then(response => {
              return response.text();
          })
          .then(data => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(data, "text/html");
               
              let checkCartDrawerFg = document.querySelector(".cart-items");
              if (checkCartDrawerFg) {
                  checkCartDrawerFg.innerHTML = doc.querySelector(".cart-items").innerHTML;
                  $('.drawer').addClass('active');
              }

            resolve();
          })
          .catch(error => {
              console.error('Ошибка:', error);
            reject(error)
          });
        })
        .catch(error => {
          console.log('Ошибка:', error);
           reject(error)
        });
  });
}

 //for sample
function removeSampleCart() {
    return new Promise(async (resolve, reject) => {
        const getCart = await fetch('/cart.js');
        const cartPorduct = await getCart.json();
  
        const sampleIds = cartPorduct.items.filter((item) => item.properties._sample);
  
        if(sampleIds && sampleIds.length > 0) {
          await fetch('/cart/clear.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              }
            })
        }
      
        resolve();
    });
}
 // form samepe end